module.exports = __webpack_public_path__ + "static/media/ribbon_y_1.a46e8894.svg";